module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_location_hokubu_beach-f15188250d0361b0a555d4e54f5316b1.jpg";